<template>
  <div>
    <v-tabs
      v-if="type !== 'set-peringkat'"
      grow
      class="mb-5"
      color="green"
      slider-color="green"
      v-model="tab"
      @change="onChangeTab"
    >
      <v-tab active-class="green--text green lighten-5">Sekolah Negeri</v-tab>
      <v-tab active-class="green--text green lighten-5">Sekolah Swasta</v-tab>
    </v-tabs>
    <base-table-header
      v-if="type !== 'set-peringkat'"
      :btn-filter="false"
      :btn-download="options && options.btnDownload"
      :options="{
        header: 'pa-0',
        filterOutline: true,
        reloadOutline: true,
        searchOutline: true,
        downloadOutline: true,
      }"
      @reload="onReload"
      @search="onSearch"
      @download="onDownload"
    >
      <template v-slot:toolbarAfter>
        <div class="ml-2" v-if="type === 'nilai'">
          <v-select
            v-model="isNilai"
            :items="mNilai"
            placeholder="Semua Data"
            dense
            outlined
            hide-details
            style="max-width: 180px"
            @input="onFilterNilai"
          ></v-select>
        </div>
        <div class="ml-2" v-if="type === 'peringkat'">
          <v-select
            v-model="isSama"
            :items="mSama"
            placeholder="Semua Data"
            dense
            outlined
            hide-details
            style="max-width: 180px"
            @input="onFilterNilaiSama"
          ></v-select>
        </div>
        <div class="ml-2" v-if="type === 'lolos'">
          <v-select
            v-model="kSeleksiPeringkatPsp"
            :items="mSeleksiPeringkat"
            placeholder="Semua Data"
            dense
            outlined
            hide-details
            style="max-width: 180px"
            @input="onFilterSeleksiPeringkat"
          ></v-select>
        </div>
        <div v-if="isEdit && type === 'nilai'" class="ml-2">
          <v-btn
            :disabled="!$allow('psp-peringkat-seleksi.upload-nilai')"
            color="primary"
            class="elevation-1 text-capitalize"
            @click="onUploadNilai"
          >
            <v-icon left dark>
              mdi-upload
            </v-icon>
            Unggah Nilai
          </v-btn>
        </div>
      </template>
    </base-table-header>
    <base-list-table
      class="mt-5"
      :hideHeader="true"
      :loading="loading"
      :item="data"
      :total="total"
      :usePaging="false"
      @fetch="fetchData"
    >
      <template slot-scope="{ item, index }">
        <td>
          <v-list three-line>
            <v-list-item dense class="px-0">
              <v-list-item-avatar
                class="my-1"
                :color="
                  ['nilai', 'set-peringkat'].includes(type)
                    ? 'secondary'
                    : `${item.nilai_sama && !item.prioritas ? 'red' : 'green'} lighten-5`
                "
              >
                <v-icon v-if="['nilai', 'set-peringkat'].includes(type)" dark>mdi-account</v-icon>
                <span
                  v-else-if="['peringkat', 'lolos'].includes(type)"
                  :class="`title ${item.nilai_sama && !item.prioritas ? 'red' : 'green'}--text`"
                >
                  {{ item.urutan }}
                </span>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-row>
                  <v-col cols="12" :md="type === 'set-peringkat' ? 7 : 4">
                    <div>
                      <span class="info--text mb-0" style="font-size: 17px">
                        {{ $getDeepObj(item, 'ptk_kasek.nama') || '-' }}
                      </span>
                      <div class="mt-1 mb-0">
                        <strong>No UKG:</strong> {{ $getDeepObj(item, 'ptk_kasek.no_ukg') || '-' }}
                      </div>
                      <div class="mt-1">
                        <strong>Jenis PTK:</strong> {{ getInfoPtk(item, 'm_jenis_ptk.jenis_ptk') || '-' }}
                      </div>
                      <div class="mt-1">
                        <strong>Tugas Tambahan:</strong> {{ getInfoTugas(item, 'm_tugas.keterangan') || '-' }}
                      </div>
                      <div class="mt-1">
                        <strong>Status Keaktifan:</strong>
                        {{ getInfoPtk(item, 'm_keluar.keterangan', 'ptk_sekolah.m_keluar.keterangan') || 'Aktif' }}
                      </div>
                      <div class="mt-1">
                        <strong>Status Kepegawaian:</strong>
                        {{ getInfoPtk(item, 'm_pegawai.keterangan') || '-' }}
                      </div>
                      <div class="mt-1">
                        <strong>Status Lulus PPPK 2021:</strong>
                        {{ +item.is_lulus_p3k_2021 ? 'Lulus' : '-' }}
                      </div>
                    </div>
                    <div class="mt-3">
                      <div>
                        <span class="body-2 grey--text text--darken-1">Informasi Sekolah</span>
                      </div>
                      <div class="mt-1">
                        <span class="mb-0 font-weight-medium" style="font-size: 17px">
                          {{ getInfoSekolah(item, 'nama') }}
                        </span>
                      </div>
                      <div class="mt-1 mb-0"> <strong>NPSN:</strong> {{ getInfoSekolah(item, 'npsn') }} </div>
                      <div class="mt-1 mb-0">
                        <strong>Status:</strong>
                        {{ Number(getInfoSekolah(item, 'is_negeri')) === 1 ? 'Negeri' : 'Swasta' }}
                      </div>
                      <div class="mt-1 mb-4"> <strong>Alamat:</strong> {{ getInfoSekolah(item, 'alamat') }} </div>
                    </div>
                  </v-col>
                  <v-col cols="12" :md="type === 'set-peringkat' ? 5 : 3">
                    <div>
                      <div class="grey--text body-2 text--darken-1">Kriteria Penilaian Pusat</div>
                      <div class="mt-1 mb-0 black--text">
                        Wawancara Panel: <strong>{{ item.nilai_ww || 0 }}</strong>
                      </div>
                      <div class="mt-1 mb-0 black--text">
                        Simulasi Mengajar: <strong>{{ item.nilai_sm || 0 }}</strong>
                      </div>
                    </div>
                    <div class="mt-4">
                      <div class="grey--text body-2 text--darken-1">Kriteria Penilaian Daerah</div>
                      <div v-if="kriteriaDinas">
                        <template v-for="id in 3">
                          <div :key="id" class="mt-1 mb-0 black--text" v-if="detail[`kriteria_dinas_nama_${id}`]">
                            {{ detail[`kriteria_dinas_nama_${id}`] }}:
                            <strong
                              v-if="item[`kriteria_dinas_nilai_${id}`] || item[`kriteria_dinas_nilai_${id}`] === 0"
                              :class="[
                                `${isValidNilaiDaerah(item[`kriteria_dinas_nilai_${id}`]) ? 'black' : 'red'}--text`,
                              ]"
                            >
                              {{ item[`kriteria_dinas_nilai_${id}`] }}
                            </strong>
                            <span
                              v-if="!item[`kriteria_dinas_nilai_${id}`] && item[`kriteria_dinas_nilai_${id}`] !== 0"
                              class="red--text"
                            >
                              Belum dinilai
                            </span>
                          </div>
                        </template>
                      </div>
                      <div v-else>
                        <span class="orange--text">Tidak Ada</span>
                      </div>
                    </div>
                    <div class="mt-4">
                      <div class="grey--text body-2 text--darken-1">Nilai akhir yang diperoleh</div>
                      <span class="mb-0" style="font-size: 17px">
                        {{ $getDeepObj(item, 'nilai_akhir') || '-' }}
                      </span>
                    </div>
                  </v-col>
                  <v-col v-if="type !== 'set-peringkat'" cols="12" md="2">
                    <div class="mb-4">
                      <span class="body-2 grey--text text--darken-1">Status Kandidat</span>
                      <div>
                        <v-icon color="info" small dark style="margin-bottom: 3px"> mdi-account </v-icon>
                        <span class="body-2 font-weight-medium black--text">
                          {{
                            Number($getDeepObj(item, 'psp_profil.is_cadangan') || 0) > 0
                              ? `Akselerasi ${$getDeepObj(item, 'psp_profil.is_cadangan')}`
                              : 'Reguler'
                          }}
                        </span>
                      </div>
                      <div v-if="+item.is_prioritas === 1" class="orange--text text--darken-3">
                        <v-icon color="info" small dark style="margin-bottom: 3px"> mdi-crown </v-icon> Prioritas
                        diterima
                      </div>
                    </div>
                    <div>
                      <div class="grey--text body-2 text--darken-1">Status</div>
                      <v-chip
                        v-if="type === 'nilai'"
                        :color="+item.is_nilai === 1 ? 'success' : !isValidNilai(item) ? 'orange' : 'error'"
                        text-color="white"
                      >
                        <v-icon left class="mr-1" style="font-size: 17px">
                          {{
                            +item.is_nilai === 1 ? 'mdi-check' : !isValidNilai(item) ? 'mdi-information' : 'mdi-close'
                          }}
                        </v-icon>
                        {{
                          +item.is_nilai === 1 ? 'Sudah dinilai' : !isValidNilai(item) ? 'Tidak Valid' : 'Belum dinilai'
                        }}
                      </v-chip>
                      <v-chip
                        v-else-if="type === 'peringkat'"
                        :color="item.nilai_sama && !item.prioritas ? 'error' : 'success'"
                        text-color="white"
                      >
                        <v-icon left class="mr-1" style="font-size: 17px">
                          {{ item.nilai_sama && !item.prioritas ? 'mdi-close' : 'mdi-check' }}
                        </v-icon>
                        {{ item.nilai_sama && !item.prioritas ? 'Nilai sama' : 'Sudah sesuai' }}
                      </v-chip>
                      <v-chip
                        v-else-if="type === 'lolos'"
                        :color="M_PROP_LOLOS[item.k_seleksi_peringkat_psp]['color']"
                        text-color="white"
                      >
                        <v-icon left class="mr-1" style="font-size: 17px">
                          {{ M_PROP_LOLOS[item.k_seleksi_peringkat_psp]['icon'] }}
                        </v-icon>
                        {{ $getDeepObj(item, 'm_seleksi_peringkat_psp.keterangan') || '' }}
                      </v-chip>
                      <div v-if="type === 'lolos' && +item.k_seleksi_peringkat_psp === 4" class="mt-1 body-2">
                        <v-icon color="black" small dark> mdi-account-cancel </v-icon>
                        {{ item.catatan_gugur }}
                      </div>
                    </div>
                    <div class="mt-4">
                      <v-btn
                        :disabled="!$allow('psp-peringkat-seleksi.save-nilai')"
                        v-if="isEdit && type === 'nilai'"
                        color="primary"
                        class="elevation-1"
                        @click="onSetNilai(item)"
                      >
                        <v-icon left dark>
                          mdi-pencil
                        </v-icon>
                        {{ +item.is_nilai === 1 ? 'Ubah' : 'Isikan' }} Nilai
                      </v-btn>
                      <v-btn
                        v-else-if="isEdit && type === 'peringkat' && item.nilai_sama"
                        color="primary"
                        class="elevation-1"
                        @click="onSetPeringkat(item)"
                      >
                        <v-icon left dark>
                          mdi-pencil
                        </v-icon>
                        Set Prioritas
                      </v-btn>
                    </div>
                  </v-col>
                  <v-col
                    v-if="
                      type !== 'set-peringkat' &&
                        [6, 9].includes(pspPeringkat.k_tahap_peringkat_psp) &&
                        ($allow('psp-peringkat-seleksi.gugur') || $allow('psp-peringkat-seleksi.batal-gugur'))
                    "
                    cols="12"
                    md="3"
                  >
                    <div class="body-2 grey--text text--darken-1">Aksi terhadap data</div>
                    <div>
                      <v-btn
                        v-if="+item.is_gugur !== 1 && $allow('psp-peringkat-seleksi.gugur')"
                        class="text-capitalize"
                        dark
                        color="red"
                        @click="onDiskualifikasi(item)"
                      >
                        <v-icon left>mdi-account-cancel</v-icon> Diskualifikasi
                      </v-btn>
                      <v-btn
                        v-else-if="$allow('psp-peringkat-seleksi.batal-gugur')"
                        class="text-capitalize"
                        color="blue"
                        dark
                        @click="onBatalDiskualifikasi(item)"
                      >
                        <v-icon left>mdi-close</v-icon> Batal Diskualifikasi
                      </v-btn>
                    </div>
                  </v-col>
                  <v-col v-if="type === 'set-peringkat'" class="pt-0" cols="12">
                    <v-alert colored-border class="pa-2 my-2 orange lighten-5" style="border-width: 0 !important;">
                      <template v-slot:prepend>
                        <v-icon class="mx-2 orange--text">mdi-alert</v-icon>
                      </template>
                      <v-row>
                        <v-col cols="12" md="7" class="my-auto">
                          Tentukan Prioritas dari <strong>{{ $getDeepObj(item, 'ptk_kasek.nama') || '-' }}</strong>
                        </v-col>
                        <v-col cols="12" md="5">
                          <v-select
                            v-model="prioritases[index]['prioritas']"
                            :items="mPrioritas"
                            solo
                            hide-details
                            dense
                            flat
                            style="border: 1px solid orange"
                          />
                        </v-col>
                      </v-row>
                    </v-alert>
                  </v-col>
                </v-row>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </td>
      </template>
    </base-list-table>
    <v-card-actions>
      <base-table-footer :pageTotal="pageTotal" @changePage="onChangePage"></base-table-footer>
    </v-card-actions>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import list from '@mixins/list';
export default {
  name: 'verval-list',
  mixins: [list],
  props: {
    kasek: {
      type: Object,
      default: () => {},
    },
    detail: {
      type: Object,
      default: () => {},
    },
    isPusat: {
      type: Boolean,
      default: false,
    },
    jenjangId: {
      tipe: Number,
    },
    type: {
      type: String,
      default: '',
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
    additionalParams: {
      default: () => {},
    },
    options: {
      default: () => {},
    },
  },

  data() {
    return {
      mNilai: [
        { text: 'Semua Data', value: '' },
        { text: 'Sudah dinilai', value: '1' },
        { text: 'Belum dinilai', value: '0' },
      ],
      mSama: [
        { text: 'Semua Data', value: '' },
        { text: 'Nilai Sama', value: '1' },
        { text: 'Nilai Tidak Sama', value: '0' },
      ],
      M_PROP_LOLOS: {
        1: { icon: 'mdi-clear', color: 'red' },
        2: { icon: 'mdi-check-circle', color: 'green' },
        3: { icon: 'mdi-alert', color: 'orange' },
        4: { icon: 'mdi-account-cancel', color: 'orange' },
      },
      isNilai: '',
      isSama: '',
      kSeleksiPeringkatPsp: '',
      tab: 0,
      prioritases: [],
    };
  },

  computed: {
    ...mapState('preferensi', {
      configPreferensi: (state) => state.data?.config ?? {},
    }),

    ...mapState('peringkat', {
      pspPeringkat: (state) => state.psp_peringkat || {},
    }),

    kriteriaDinas() {
      let result = false;

      for (let i = 1; i <= 3; i++) {
        if (!result) {
          result = !!this.detail[`kriteria_dinas_nama_${i}`];
        }
      }

      return result;
    },

    batasNilai() {
      const nilaiMin = Number(this.$getDeepObj(this.detail, 'konfigurasi.nilai_min')) || 0;
      const rentang = Number(this.$getDeepObj(this.configPreferensi, 'peringkat.rentang_nilai_dinas') || 0);

      return {
        min: nilaiMin,
        max: nilaiMin + rentang,
      };
    },

    mJenjang() {
      const jenjangs = this.$getDeepObj(this.pspPeringkat, 'instansi.m_jenis_instansi.instansi_jenjangs') || [];

      return [
        ...[{ text: 'Semua Jenjang', value: '' }],
        ...jenjangs
          .filter((jenjang) => jenjang.k_jenjang < 6)
          .map((jenjang) => {
            return {
              text: this.$getDeepObj(jenjang, 'm_jenjang.singkat'),
              value: jenjang.k_jenjang,
            };
          }),
      ];
    },

    mPrioritas() {
      let options = [];

      for (let i = 1; i <= this.prioritases.length; i++) {
        options.push({ text: `Prioritas ${i}`, value: i });
      }

      return options;
    },

    mSeleksiPeringkat() {
      return [
        { text: 'Semua Data', value: '' },
        { text: 'Belum', value: 1 },
        { text: 'Diterima', value: 2 },
        { text: 'Cadangan', value: 3 },
      ];
    },

    isViewDataOri() {
      return !this.isPusat && [6, 9].includes(this.pspPeringkat.k_tahap_peringkat_psp);
    },
  },

  methods: {
    ...mapActions('peringkat', ['fetch']),
    ...mapActions('peringkatVerval', ['getNilai']),

    fetchData: function() {
      this.params = Object.assign({}, this.params, { is_negeri: this.tab === 1 ? 0 : 1 });
      this.attr = {
        action: 'seleksi',
        id: this.isPusat ? this.jenjangId : this.detail.psp_peringkat_jenjang_id,
        type: this.type === 'nilai' ? 'nilai' : this.type === 'lolos' ? 'lolos' : 'prioritas',
      };

      if (this.type === 'set-peringkat') {
        this.params = Object.assign({}, this.params, { is_negeri: this.kasek.is_negeri });
        this.filters = Object.assign({}, this.filters, { nilai_sama: this.kasek.nilai_sama });
      }

      if (this.additionalParams && this.$isObject(this.additionalParams)) {
        this.filters = Object.assign({}, this.filters, this.additionalParams);
      }

      return new Promise((resolve) => {
        const params = Object.assign({}, this.params, this.$isObject(this.filters) ? this.filters : {});
        const attr = Object.assign({}, this.attr);
        this[this.isPusat ? 'getNilai' : 'fetch']({ params, attr }).then(({ data, meta, total, last_page }) => {
          this.data = data || [];
          this.total = meta?.total || total || 0;
          this.pageTotal = meta?.last_page || last_page || 1;
          this.params.limit = meta?.per_page || this.params.limit;
          this.statistik = meta?.statistik || {};
          this.config = meta?.config || {};
          resolve(true);
        });
      });
    },

    reset() {
      this.data = [];
      this.prioritases = [];
    },

    getInfoPtk(data, key, keyAsal) {
      return this.$borangInfoPtk(data, this.isViewDataOri, key, keyAsal);
    },

    getInfoTugas(data, key) {
      return this.$borangInfoTugas(data, this.isViewDataOri, key);
    },

    getInfoSekolah(data, key) {
      return this.$borangInfoSekolah(data, this.isViewDataOri, key);
    },

    getPeringkat() {
      return this.prioritases.map((p, id) => {
        return {
          psp_peringkat_kandidat_id: this.data[id]['psp_peringkat_kandidat_id'] || '',
          prioritas: p.prioritas,
        };
      });
    },

    isValidNilai(kasek) {
      let valid = true;

      for (let i = 1; i <= 3; i++) {
        if (this.detail[`kriteria_dinas_nama_${i}`] && valid) {
          valid =
            kasek[`kriteria_dinas_nilai_${i}`] >= this.batasNilai.min &&
            kasek[`kriteria_dinas_nilai_${i}`] <= this.batasNilai.max;
        }
      }

      return valid;
    },

    isValidNilaiDaerah(nilai) {
      return nilai >= this.batasNilai.min && nilai <= this.batasNilai.max;
    },

    onChangeTab() {
      Object.assign(this.params, { is_negeri: this.tab === 1 ? 0 : 1 });
      this.fetchData();
    },

    onFilterNilai() {
      delete this.filters['is_nilai'];

      if (this.isNilai) {
        this.filters = Object.assign(this.filters, { is_nilai: this.isNilai });
      }

      Object.assign(this.params, { page: 1 });
      this.fetchData();
    },

    onFilterNilaiSama() {
      delete this.filters['is_sama'];

      if (this.isSama) {
        this.filters = Object.assign(this.filters, { is_sama: this.isSama });
      }

      Object.assign(this.params, { page: 1 });
      this.fetchData();
    },

    onFilterSeleksiPeringkat() {
      delete this.filters['k_seleksi_peringkat_psp'];

      if (this.kSeleksiPeringkatPsp) {
        this.filters = Object.assign(this.filters, { k_seleksi_peringkat_psp: this.kSeleksiPeringkatPsp });
      }

      Object.assign(this.params, { page: 1 });
      this.fetchData();
    },

    onUploadNilai() {
      this.$emit('upload', { is_negeri: this.params.is_negeri });
    },

    onSetNilai(kasek) {
      this.$emit('nilai', kasek);
    },

    onSetPeringkat(kasek) {
      this.$emit('peringkat', kasek);
    },

    onChangeData(data) {
      for (const p of data) {
        this.prioritases.push({ prioritas: p.prioritas || null });
      }
    },

    onDownload() {
      this.$emit('download', this.params);
    },

    onDiskualifikasi(item) {
      this.$emit('gugur', item);
    },

    onBatalDiskualifikasi(item) {
      this.$emit('batalgugur', item);
    },
  },

  watch: {
    data: 'onChangeData',
  },
};
</script>
